
import CreateAuction from '@/components/CreateAuction.vue'

export default {
  components: { CreateAuction },
    name: 'Create',
    component: CreateAuction
}
